import React from "react";

export default function LogoDisplay() {
  return (
    <div className="logo-display-container">
      
      <div className="school-club-logos">
        <img src="/crest.svg" alt="School Crest" id="crest"/>
        <img src="/RCCS.webp" alt="RCCS Logo" id="rccs"/>
      </div>
    </div>
  );
}
